<template lang="">
  <div class="detail-view">
    <Header :nosearch="true" :title="`${stockname}-${titleName}`"/>
    <div class="detail-header">
      <div class="title">
        {{detail.title}}
      </div>
      <div class="sub-media" v-if="type === '1' || type === '5' ">
        <span style="padding-right: 10px;" v-if="detail.media && detail.media.length > 0">{{detail.media}}</span>
        <span>{{detail.pushtime}}</span>
      </div>
      <div class="sub-pdf" v-if="type === '2' || type === '6' ">
        <span>{{detail.pushtime}}</span>
        <p class="pdf-btn" @click="lookpdf" v-if="!isETF"><i class="pdf-icon"></i>查看全文</p>
      </div>
      <div class="sub-pdf" style="padding-bottom: 0" v-if="type === '4'">
        <span>{{detail.showTime}}</span>
        <!-- <p class="pdf-btn" @click="lookpdf"><i class="pdf-icon"></i>查看全文</p> -->
      </div>
      <div class="sub-yanbao" v-if="type === '3' || type === '7' ">
        <template v-if="detail.content && detail.content.length > 0">
          <div>
            <span>{{detail.orgName}}</span>
            <span v-show="detail.typeName" class="sub-type">{{detail.typeName}}</span>
          </div>
          <p class="pdf-btn" @click="lookpdf" v-if="detail.pdfUrl"><i class="pdf-icon"></i>查看全文</p>
        </template>
        <template v-else>
            <div>
                <span>{{ detail.orgName }}</span>
                <span v-show="detail.typeName" class="sub-type">{{
                    detail.typeName
                }}</span>
            </div>
        </template>
      </div>
    </div>
    <div class="detail-dyna" v-show="type === '1' || type === '5'" @click="goHome">
      <label>{{stockname}}</label>
      <span :style="`padding-left: 10px;font-weight: 600; color: ${dyna.Updown > 0 ? color[0]: (dyna.Updown === 0 ? color[1] : color [2])}`">
        {{ !dyna.Updown ? '--' :
            dyna.Updown > 0 ? '+' + (dyna.Updown * 100).toFixed(2) + '%' : 
            dyna.Updown === 0 ? (dyna.Updown * 100).toFixed(2) + '%' : 
            (dyna.Updown * 100).toFixed(2) + '%'
          }}
      </span>
    </div>
    <div v-if="detail.content && detail.content.length > 0" class="detail-content" :class="{'stock-focus': type == 4}" v-html="detail.content"></div>
    <div v-else-if="detail.title" class="detail-content">
      <label>该公告为独立文件：</label>
      <div class="pdf-btn" @click="lookpdf">点击查看PDF全文</div>
    </div>
    <div class="detail-mianze" v-if="type === '1' || type === '5'">
      <p>免责声明</p>
      <p>以上内容仅供用户参考和学习使用，不构成投资建议，不具有任何投资咨询信息性质，不构成对包括但不限于股票、债券、期货、期权等任何金融产品的收购、购买、认购、抛售或持有的要约邀请、要约或承诺，不能确保您获得盈利或本金不受损失，且不作为您投资的依据，您须独立作出投资决策，风险自担。投资有风险，入市需谨慎。</p>
    </div>

    <div v-if="type === '1' || type === '5'" style="height: 0.06rem;background: #f5f5f5;"></div>

    <div class="other-list" v-if="type === '1' || type === '5'">
      <div class="other-title">
        推荐阅读
      </div>
      <div class="other-item" v-for="item in list.slice(0,5)" :key="item.newsId" @click="goDetail(item)">
        <p class="title">{{item.title}}</p>
        <p class="time">{{item.date}}</p>
      </div>
      <!-- <infinite-loading @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
        <div slot="no-more">无更多数据</div>
        <div slot="no-results">无咨询数据</div>
        <div slot="spinner" class="tab-spinner">正在加载...</div>
      </infinite-loading> -->
    </div>
    <a download :href="detail.pdfUrl" ref="downloadpdf"/>
  </div>
</template>

<script>
import moment from 'moment'
import Header from '@/components/header.vue'
import { request } from '@/api/request'
import { mapState, mapMutations } from 'vuex'

function marketTransform(val) {
    let keytmar = {
        NASDAQ: 'NASDAQ',
        nasdqa: 'NASDAQ',
        NA: 'NASDAQ',
        sh: 'sh',
        SH: 'sh',
        sz: 'sz',
        SZ: 'sz',
        HK: 'HKSE',
        hk: 'HKSE',
        hkse: 'HKSE',
        AMEX: 'AMEX',
        amex: 'amex',
        AM: 'AMEX',
        am: 'AMEX',
        HKIDX: 'HKIDX',
        hkidx: 'HKIDX'
    }
    return keytmar[val] || val
}

export default {
    data() {
        return {
            detail: {},
            type: this.$route.params.type,
            id: this.$route.params.id,
            // market: this.$route.params.market,
            // code: this.$route.params.code,
            list: [],
            pageNo: 0,
            color: ['#e63535', '#0A1428', '#1BAA3C']
            // stockname: ''
        }
    },
    components: {
        Header,
        // InfiniteLoading
    },
    computed: {
        ...mapState({
            tabs: state => state.common.tabs,
        }),
        ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'symbol']),
        titleName() {
            // const focus = this.tabs.filter(v => v.key === 'focus')[0]
            switch (this.type) {
                case '1':
                    return '资讯'
                case '2':
                    return '公告'
                case '5':
                    return '资讯'
                case '6':
                    return '公告'
                case '4':
                    return '九方速递'
                default:
                    return '研报'
            }
        },
        isETF() {
            return !!~this.market.toLowerCase().indexOf('etf')
        }
    },
    async created() {
        console.log('进入该页面====',this.$route.params)
        this.$store.commit('setSymbol', this.$route.params)
        let stockname = await this.getStockName()
        this.$store.commit('setStockName', stockname)
        this.initData()
        window.scrollTo(0, 0)
    },
    methods: {
        ...mapMutations({
            setTabIndex: 'common/setTabIndex',
            setTabs: 'common/setTabs',
        }),

        async getSpecialName() {
            const result = await request.get({
                url: request.apis.news.getSpecifiedColumnList,
                params: {
                    market: this.market,
                    symbol: this.symbol,
                    columnCodes: '9fztgw_jfsd',
                    appCode: '9fztgw',
                    showPermission: 0,
                },
                headers: {
                    whiteList: 'rjhy-news'
                }
            })
            if (result) {
                const { newsList, columnBeans } = result
                const res = this.tabs.filter(v => v.key == 'focus')[0]
                if (res) {
                    res.label = columnBeans['9fztgw_jfsd']
                    res.list = newsList
                    this.setTabs(this.tabs)
                }
            }
        },
        /**
         * 获取个股名称
         */
        async getStockName() {
            if (this.$store.state.market.toLowerCase() === 'bj') {
                const res = await request._get(request.apis.quote.getHandicap, {
                    market: 'bj',
                    symbol: this.$store.state.code,
                }, true);
                return res && res.prodName || ''
            }
            let market = marketTransform(this.$store.state.market)
            let symbol = this.$store.state.code
            if (this.$store.state.isIndex && this.$store.state.region === 'CN') market = market.toLowerCase()
            if (this.$store.state.region === 'HK') {
                symbol = symbol.length === 4 && /\d+/.test(symbol) ? '0' + symbol : symbol
            }
            let res = await request.get({
                url: request.apis.quote.getStockName,
                params: {
                    symbol,
                    market,
                }
            })

            if (res && res.length > 0) {
                return res[0].Name
            }
        },
        goHome() {
            this.setTabIndex(0)
            this.$router.push({
                path: '/',
                query: {
                    market: this.market,
                    code: this.symbol
                }
            })
        },
        goDetail(zixun) {
            const { newId } = zixun
            this.$router.replace(`/detail/${this.market}/${this.symbol}/5/${newId}.html`)
            location.reload()
        },
        fillDataNewsDetails(content) {
            let regx = /<p>/
            if (!regx.test(content)) {
                content = '<p>' + content.replace(/\r/gm, '\n');
                content = content.replace(/\s\s+/, '\n');
                // content = content.replace(/\s\s/, '\n');
                content = content.replace(/\n\s+/gm, '\n');
                // content = content.replace(/\n\s\s\s\s/gm, '\n');
                // content = content.replace(/\n\s\s\s/gm, '\n');
                // content = content.replace(/\n\s\s/gm, '\n');
                content = content.replace(/<table/gm, '<div class="table"><table');
                content = content.replace(/<\/table>/gm, '</table></div>');
                content = content.replace(/\n+/gm, '</p><p>') + '</p>';
                content = content.replace(/<p><\/p>/gm, '');
                // if (content.match(reg)) {
                //     that.zs = content.match(reg).length;
                //     that.fz = Math.ceil(that.zs / 300);
                // }
                // if (that.fz == 0) {
                //     that.fz = 1;
                // }
                // if (undefined != data.SecuCode) {
                //     for (var i = 0; i <= secuCodeArr.length - 1; i++) {
                //         content = content.replace(secuAbbrArr[i].replace(/\s/g, ""), '<a style="color:#2864C8" id=' + secuCodeArr[i] + '>' + secuAbbrArr[i].replace(/\s/g, "") + '</a>');
                //     }
                // }
            }
            return content
        },
        async initData() {
            let url = ''
            let params = {}
            switch (this.type) {
                case '1': {
                    this.getListData()
                    try {
                        let res = await request._get(request.apis.quote.newsDetailv2, {
                            news_id: this.id.replace(/\s/g, ''),
                            nocache: 1,
                        }, true)
                        // let res = await request.get({
                        //     url: request.apis.quote.newsDetail,
                        //     params: {
                        //         market: this.market,
                        //         symbol: this.symbol,
                        //         news_id: this.id.replace(/\s/g, ''),
                        //         url: `${this.$route.query.url}&dv=${this.$route.query.dv}`
                        //     }
                        // })
                        this.detail = {
                            type: 1,
                            title: res.title,
                            media: res.media,
                            pushtime: this.showtime(res.ctime > 10000000000 ? res.ctime : res.ctime * 1000),
                            content: this.fillDataNewsDetails(res.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" '))
                        }
                    } catch (error) {
                        let res = await request.get({
                            url: request.apis.quote.newsDetail.replace('v2', ''),
                            params: {
                                market: this.market,
                                symbol: this.symbol,
                                news_id: this.id.replace(/\s/g, ''),
                                url: `${this.$route.query.url}&dv=${this.$route.query.dv}`
                            }
                        })
                        this.detail = {
                            type: 1,
                            title: res.title,
                            media: res.media,
                            pushtime: this.showtime(res.ctime > 10000000000 ? res.ctime : res.ctime * 1000),
                            content: res.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" ')
                        }
                    }
                    break;
                }
                case '2': {
                    let res = await request._get(request.apis.quote.announcementDetailv2, {
                        eventId: this.id.replace(/\s/g, ''),
                        nocache: 1,
                    }, true)

                    // let res = await request.get({
                    //     url: request.apis.quote.announcementDetail,
                    //     params: {
                    //         eventId: this.id.replace(/\s/g, ''),
                    //         market: marketTransform(this.market)
                    //     }
                    // })

                    this.detail = {
                        type: 1,
                        title: res.eventName,
                        // media: res.eventType,
                        pushtime: res.eventDate,
                        content: res.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" '),
                        pdfUrl: res.pdf_link
                    }
                    break;
                }
                case '3': {
                    let data = await request.get({
                        url: request.apis.quote.detailByNewsId,
                        params: {
                            reportId: this.id.replace(/\s/g, ''),
                            // market: this.market
                        }
                    })

                    let res = data[0]

                    this.detail = {
                        type: 1,
                        title: res.title,
                        orgName: res.orgName,
                        typeName: res.type,
                        content: res.abstract.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" '),
                        pdfUrl: res.s3url,
                        pushtime: this.showtime(res.publishDate)
                    }
                    break;
                }
                case '4': {
                    let data = await request._get(request.apis.news.getArticleDetail,
                        {
                            newsId: this.id
                        }, true
                    )
                    this.detail = {
                        content: data.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img style="display:block" width="100%" '),
                        showTime: this.showtime(data.showTime),
                        title: data.title,
                    }
                    console.log('datadata', data)
                    break;
                }
                case '5': {
                    this.getListData()
                    let data = await request._get(request.apis.quote.newsDetailNew,
                        {
                            newsId: this.id
                        }, 
                        true,
                        true,
                        '9fztgw'
                    )
                    this.detail = {
                        content: data.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img style="display:block" width="100%" '),
                        pushtime: this.showtime(data.showTime),
                        title: data.title,
                        media: data.source
                    }
                    console.log('datadata', data)
                    break;
                }
                case '6': {
                    let data = await request._get(request.apis.quote.announcementDetailNew,
                        {
                            newsId: this.id
                        }, 
                        true,
                        true,
                        '9fztgw'
                    )
                    this.detail = {
                        content: data.content.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img style="display:block" width="100%" '),
                        pushtime: this.showtime(data.showTime),
                        pdfUrl: data.pdfLink,
                        title: data.title,
                    }
                    console.log('datadata', data)
                    break;
                }
                case '7': {
                    console.log('打印接口===',request.apis.quote.detailByNewsIdNew)
                    let res = await request._get(request.apis.quote.detailByNewsIdNew,
                        {
                            reportId: this.id
                        },
                        true,
                        true,
                        '9fztgw'
                    )
                    this.detail = {
                        title: res.title,
                        orgName: res.orgName,
                        typeName: res.type,
                        content: res.abstract.replace(/<a\s*[^>]*>(.*?)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" '),
                        pdfUrl: res.s3url,
                        pushtime: this.showtime(res.publishDate)
                    }
                    console.log('datadata', res)
                    break;
                }
                default:
                    break;
            }
        },
        /**
         * 获取list 数据
         */
        async getListData() {
            let res = await request._get(
                request.apis.quote.articles,
                {
                    market: this.market,
                    symbol: this.symbol,
                    limit: 6,
                    dataType: 1,
                },
                true,
                true,
                '9fztgw'
            )
            this.list = res.filter(_ => _.newId != this.id)
            this.list.forEach(item => item.date = moment(item.releaseTime).format('MM-DD HH:mm'))
        },
        lookpdf() {
            // window.open(this.detail.pdfUrl)
            console.log(this.$refs.downloadpdf.click())
            this.$refs.downloadpdf.click()
        },
        showtime(_date) {
            let day = moment(new Date())
            let date = moment(_date)
            if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
                return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else if (day.year() === date.year()) {
                return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else {
                return `${date.year()}-${date.month() + 1}-${date.date()}`
            }
        }
    },
    filters: {
        showtime(_date) {
            let day = moment(new Date())
            let date = moment(_date)
            if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
                return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else if (day.year() === date.year()) {
                return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else {
                return `${date.year()}-${date.month() + 1}-${date.date()}`
            }
        },
    }
}
</script>

<style lang="stylus">
.detail-view
    background #fff
    margin-top 0.4rem
    min-height 100vh

    .detail-dyna
        padding 8px 0
        margin 0 12px
        border-top 1px solid #f5f5f5
        border-bottom 1px solid #f5f5f5

    .detail-header
        padding 12px 0 0 0
        margin 0 12px

        .title
            font-size 17px
            color #1f2126
            font-weight 600

        .sub-media
            color #999999
            font-size 12px
            padding 6px 0

        .sub-yanbao
            color #999999
            font-size 12px
            padding 6px 0
            display flex
            justify-content space-between
            align-items center

            .sub-type
                border 1px solid rgb(64, 154, 251)
                color rgb(64, 154, 251)
                padding 2px
                font-size 10px
                margin-left 8px

        .sub-pdf
            display flex
            font-size 12px
            color #999
            align-items center
            justify-content space-between
            padding 7px 0 21px 0

        .pdf-btn
            width 102px
            height 26px
            background #409afb
            font-size 12px
            color #fff
            display flex
            align-items center
            justify-content center

        .pdf-icon
            background url('../../assets/pdfbtn.png')
            width 16px
            height 20px
            background-size contain
            display block
            margin-right 6px

    .detail-content
        padding 10px 0
        margin 0 12px
        font-size 15px
        color #1f2126
        overflow scroll
        white-space pre-wrap

        >section
            padding 0 !important

        p
            margin-bottom 0.2rem
            text-indent 0.25rem
            line-height 28px

            img
                margin auto

        .pdf-btn
            text-align center
            margin 20px auto
            width 200px
            height 30px
            line-height 30px
            background #409afb
            // font-size 12px
            color #fff

    .detail-mianze
        font-size 12px
        color #bbb
        margin 20px 12px
        padding 0 12px

    .other-list
        margin 0 12px

        .other-title
            font-size 15px
            height 21px
            font-weight 600
            line-height 21px
            border-bottom 1px solid #edeff3
            padding 13px 0 6px 0

        .other-item
            padding 9px 0
            border-bottom 1px solid #f5f5f5

            .title
                color #333
                font-size 15px
                font-weight 400

            .time
                color #999
                font-size 12px

.stock-focus
    margin-top -15px !important
    padding-top 0 !important
</style>

<style lang="stylus">
.article-img
    max-width 100%
</style>